import React from 'react';

import cx from 'classnames';

import Text from '../../../Typography/Text';
import ContactItem from './ContactItem';
import s from './index.module.css';
import { IContactsBlockProps } from './types';

function ContactsBlock({ data: blockData }: IContactsBlockProps) {
  return (
    <div className={cx(s.contactsBlock, 'custom-contacts')}>
      {blockData.data.types.map((contactsType) => (
        <div key={contactsType.type} className={cx(s.contactsTypeBlock, 'custom-contacts-type')}>
          <div className={cx(s.itemHeader, 'custom-contacts-header')}>
            <Text className={cx(s.itemHeaderText, 'custom-contacts-header-text')}>{contactsType.type}</Text>
          </div>
          {contactsType.items.map((it) => (
            <ContactItem key={it.id} item={it} />
          ))}
        </div>
      ))}
    </div>
  );
}

export default ContactsBlock;
